import React, { useEffect, useState } from 'react'
import ViewNewProperty from './ViewNewProperty'
import { Routes, Route, Outlet, useParams, Navigate } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import PropertyOverview from './PropertyOverview'
import PropertySubdivisions from './PropertySubdivisions'
import PropertyImageUpload from './PropertyImageUpload'
import PropertyDocumentsUpload from './PropertyDocumentsUpload'
import { property_View } from './View_Property_Api'
import { ShowImg } from '../Property_Api'
import PropertyInventory from './PropertyInventory'
import { propertyDetailsDataType, propertyImageDataType } from '../PropertyDataTypes'
import Swal from 'sweetalert2'
import PropertyCreateAgreement from './PropertyCreateAgreement'
import PropertyGSTDetails from './PropertyGSTDetails'

// const profileBreadCrumbs: Array<PageLink> = [
//   { title: 'Property Details', path: '/property', isSeparator: false, isActive: false },
//   { title: '', path: '', isSeparator: true, isActive: false },
// ]

const ViewNewPropertyRoutes = () => {
  const [propertyDetails, setPropertyDetails] = useState<propertyDetailsDataType>()
  const [propertyImages, setPropertyImages] = useState<propertyImageDataType[]>()
  const [propertyImageLoading, setPropertyImageLoading] = useState<boolean>(false)

  // params: property_uuid used for dynamic routing
  const { id } = useParams()

  // function to get property details
  const get_view_property = async () => {
    if (id) {
      // setLoading(true)
      try {
        const { data: response } = await property_View(id)
        if (response.code === '200') {
          setPropertyDetails(response.data[0])
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
            text: response.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      }
    }
  }
  // function to get property images
  const get_Img = async () => {
    if (id) {
      setPropertyImageLoading(true)
      try {
        const { data: response } = await ShowImg(id)
        if (response.code === '200') {
          setPropertyImages(response.data)
        }
        else if (response.code === '500') {
          setPropertyImages(response.data)
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
            text: response.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      } finally {
        setPropertyImageLoading(false)
      }
    }
  }

  // fetch property_details and images onload
  useEffect(() => {
     // setLoading(true)
     const fetchData = async () => {
      try {
        await Promise.all([get_view_property(), get_Img()])
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      } 
      // finally {
      //   setLoading(false)
      // }
    }
    fetchData()
  }, [])
  return (
    <>
      <Routes>
        {/* Begin: main route view property */}
        <Route
          element={
            <>
              <ViewNewProperty
                propertyDetails={propertyDetails}
                id={id}
                get_view_property={get_view_property}
                propertyImageLoading={propertyImageLoading}
                propertyImage={(propertyImages && propertyImages?.length > 0) ? propertyImages[0].property_image_path : undefined}
              />
              <Outlet />
            </>
          }
        >
          {/* Begin: child route overview */}
          <Route
            path='overview'
            element={
              <>
                {/* <PageTitle breadcrumbs={profileBreadCrumbs}>Overview</PageTitle> */}
                <PageTitle>Overview</PageTitle>
                {
                  propertyDetails && <PropertyOverview
                    overviewDetails={propertyDetails}
                    get_view_property={get_view_property}
                  />
                }
              </>
            }
          />
          {/* End: child route overview */}
          {/* Begin: child route subdivisions */}
          <Route
            path='subdivisions'
            element={
              <>
                {/* <PageTitle breadcrumbs={profileBreadCrumbs}>Subdivisions</PageTitle> */}
                <PageTitle>Subdivisions</PageTitle>
                {
                  propertyDetails &&
                  <PropertySubdivisions
                    overviewDetails={propertyDetails}
                    get_view_property={get_view_property}
                  />}
              </>
            }
          />
          {/* End: child route subdivisions */}
          {/* Begin: child route images */}
          <Route
            path='images'
            element={
              <>
                {/* <PageTitle breadcrumbs={profileBreadCrumbs}>Images</PageTitle> */}
                <PageTitle>Images</PageTitle>
                {
                  (id && propertyImages) &&
                  <PropertyImageUpload
                    id={id}
                    propertyImages={propertyImages}
                    propertyImageLoading={propertyImageLoading}
                    get_view_property={get_view_property}
                    get_Img={get_Img}
                  />
                }
              </>
            }
          />
          {/* End: child route images */}
          {/* Begin: child route documents */}
          <Route
            path='documents'
            element={
              <>
                {/* <PageTitle breadcrumbs={profileBreadCrumbs}>Documents</PageTitle> */}
                <PageTitle>Documents</PageTitle>
                <PropertyDocumentsUpload id={id} />
              </>
            }
          />
          {/* End: child route documents */}
          {/* Begin: child route inventory */}
          <Route
            path='inventory'
            element={
              <>
                {/* <PageTitle breadcrumbs={profileBreadCrumbs}>Inventory</PageTitle> */}
                <PageTitle>Inventory</PageTitle>
                {
                  (id && propertyDetails) &&
                  <PropertyInventory
                    propertyDetails={propertyDetails}
                    id={id}
                    get_view_property={get_view_property}
                  />
                }
              </>
            }
          />
          {/* End: child route inventory */}
          {/* Begin: child route inventory */}
          <Route
            path='agreement'
            element={
              <>
                {/* <PageTitle breadcrumbs={profileBreadCrumbs}>Create agreement</PageTitle> */}
                <PageTitle>Create agreement</PageTitle>
                {
                  (propertyDetails && id) &&
                  <PropertyCreateAgreement
                  propertyDetails={propertyDetails}
                  id={id}
                  get_view_property={get_view_property}
                />
                }
              </>
            }
          />
          {/* End: child route inventory */}
          {/* Begin: child route inventory */}
          <Route
            path='gst'
            element={
              <>
                {/* <PageTitle breadcrumbs={profileBreadCrumbs}>Create agreement</PageTitle> */}
                <PageTitle>GST Details</PageTitle>
                {
                  propertyDetails?.property_uuid &&
                  <PropertyGSTDetails property_uuid={propertyDetails?.property_uuid} />
                }
              </>
            }
          />
          {/* End: child route inventory */}
        </Route>
        <Route index element={<Navigate to={`/property/${id}/overview`} />} />
        <Route path='*' element={<Navigate to='/404' />} />
        {/* End: main route view property */}
      </Routes>
    </>
  )
}

export default ViewNewPropertyRoutes
